"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CommonBaseError_1 = require("../Common/CommonBaseError");
exports.ChatMessageAttachmentStoreErrorName = "ChatMessageAttachmentStoreError";
class ChatMessageAttachmentStoreError extends CommonBaseError_1.CommonBaseError {
}
exports.ChatMessageAttachmentStoreError = ChatMessageAttachmentStoreError;
//# sourceMappingURL=IChatMessageAttachmentStore.js.map